//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import store from '@vue/store';
import _ from 'lodash';
export default {
  props: {
    entries: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    setDate: function setDate() {
      return store.getters['app/setDate'];
    }
  },
  methods: {
    hasData: function hasData(data) {
      switch (true) {
        case data == '':
        case _.isNull(data):
        case _.isUndefined(data):
          return false;

        default:
          return true;
      }
    },
    isPageless: function isPageless(data) {
      try {
        var res = _.get(data, 'customFields.is_pageless');

        if (res.value == '1') {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    externalLink: function externalLink(data) {
      try {
        var res = _.get(data, 'customFields.external_link');

        if (this.hasData(res.value)) {
          return res.value;
        } else {
          return null;
        }
      } catch (error) {
        return null;
      }
    },
    getAttachment: function getAttachment(data) {
      try {
        var res = _.get(data, 'customFields.attachment');

        if (this.hasData(res.value)) {
          var div = document.createElement('div');
          div.innerHTML = res.value;
          var href = div.querySelector('span a').getAttribute('href');
          return href;
        } else {
          return null;
        }
      } catch (error) {
        return null;
      }
    }
  }
};